import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import Home from "../views/Home.vue";
import { $config } from "../conf";
import Cookie from "js-cookie";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
// replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: "因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/personal",
    name: "personal",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Personal.vue"),
    meta: {
      title: "个人中心-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/cloud-form",
    name: "cloudForm",
    component: () => import("../views/cloud/form.vue"),
    meta: {
      title: "我要上云-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  // {
  //   path: "/exhibitionDetail",
  //   name: "exhibitionDetail",
  //   component: () => import("../views/exhibition/Details"),
  //   meta: {
  //     title: "云数据中心-因聚而生 为你所能|华为伙伴暨开发者大会2022",
  //   },
  // },
  {
    path: "/news-list",
    name: "news",
    component: () => import("../views/news/List.vue"),
    meta: {
      title: "热门资讯-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/parallel-detail",
    name: "parallelDetail",
    component: () => import("../views/Parallel/ParallelDetail.vue"),
    meta: {
      title: "因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/video-list",
    name: "videos",
    component: () => import("../views/Videos.vue"),
    meta: {
      title: "精彩视频-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/privacy", //隐私保护
    name: "privacy",
    component: () => import("../views/other/Privacy.vue"),
    meta: {
      title: "隐私保护-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/legal", //法律声明
    name: "legal",
    component: () => import("../views/other/Legal.vue"),
    meta: {
      title: "法律声明-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/parallel", //分会场联动
    name: "parallelSessions",
    component: () => import("../views/Parallel/Parallel.vue"),
    meta: {
      title: "分会场联动-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },

  // {
  //   path: "/guide",
  //   name: "guide",
  //   component: () => import("../views/guide/Index.vue"),
  //   meta: {
  //     title: "参会指南-因聚而生 为你所能|华为伙伴暨开发者大会2022",
  //   },
  // },
  {
    path: "/bigview",
    name: "bigview",
    component: () => import("../views/bigView/BigView.vue"),
    meta: {
      title: "大咖观点-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  // {
  //   path: "/partner",
  //   name: "partner",
  //   component: () => import("../views/partner/Partner.vue"),
  //   meta: {
  //     title: "合作伙伴-因聚而生 为你所能|华为伙伴暨开发者大会2022",
  //   },
  // },
  // {
  //   path: "/exhibition",
  //   name: "exhibition",
  //   component: () => import("../views/exhibition/Exhibition.vue"),
  //   meta: {
  //     title: "展区导览-因聚而生 为你所能|华为伙伴暨开发者大会2022",
  //   },
  // },
  {
    path: "/guest",
    name: "guest",
    component: () => import("../views/guest/Guest.vue"),
    meta: {
      title: "重磅嘉宾-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/agenda",
    name: "agenda",
    component: () => import("../views/agenda/Index.vue"),
    meta: {
      title: "大会议程-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/cityTravel",
    name: "cityTravel",
    component: () => import("../views/cityTravel/cityTravelIndex.vue"),
    meta: {
      title: "区域活动-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/cityTravelList",
    name: "cityTravelList",
    component: () => import("../views/cityTravel/cityTravelList.vue"),
    meta: {
      title: "区域活动-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  {
    path: "/cityTravelDetail",
    name: "cityTravelDetail",
    component: () => import("../views/cityTravel/cityTravelDetail.vue"),
    meta: {
      title: "区域活动-因聚而生 为你所能|华为伙伴暨开发者大会2022",
    },
  },
  // {
  //   path: "/sweepingMonk",
  //   name: "sweepingMonk",
  //   component: () => import("../views/sweepingMonk/Index.vue"),
  //   meta: {
  //     title: "扫地僧见面会-因聚而生 为你所能|华为伙伴暨开发者大会2022",
  //   },
  // },
  // {
  //   path: "/live",
  //   name: "live",
  //   component: () => import("../views/live/Index.vue"),
  //   meta: {
  //     title: "大会直播-因聚而生 为你所能|华为伙伴暨开发者大会2022",
  //   },
  // },
];
const router = new VueRouter({
  mode: "history",
  routes,
  base: process.env.VUE_APP_BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});

const blackList = ["personal"]; // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  }

  if (!store.state.userInfo.globalUserId) {
    await store.dispatch("userInfo/init");
  }

  const tokenInfo = await store.dispatch("userInfo/getToken");
  const { signUpOnlineUrl } = $config;
  if (tokenInfo && tokenInfo.smarketToken) {
    if (store.state.userInfo.AttendanceStatus) {
      next();
    } else {
      store
        .dispatch("userInfo/checkRegister")
        .then(() => {
          //报名后回来 如果状态是 未线上线下报名  跳转核验票码页
          if (window.location.href.indexOf("isLoginReturn=1") > -1) {
            if (store.state.userInfo.AttendanceStatus === 3) {
              //若是 登录返回并且 报名状态是 3
              const { signOnlineUrl } = $config;
              window.location.href = `${signOnlineUrl}?returnUrl=${encodeURIComponent(
                location.href
              )}`;
            }
          }
          document.documentElement.scrollTop = 0;
          next();
        })
        .catch((error) => {
          if (error.status == 401) {
            Cookie.remove("tur_token_info", {
              expires: -1,
              path: "/",
              domain: ".huawei.com",
            });
            const { signUpOnlineUrl } = $config;
            window.location.href = `${signUpOnlineUrl}?returnUrl=${encodeURIComponent(
              location.href
            )}`;
          }
          store.dispatch("userInfo/logout");
          document.documentElement.scrollTop = 0;
          next({ name: "home" });
        });
    }
  } else {
    if (blackList.indexOf(to.name) !== -1) {
      if (!!this && this.$store.state.isMiniProgram) {
        //判断若是小程序，不去登录
        return false;
      }
      window.location.href = `${signUpOnlineUrl}?returnUrl=${encodeURIComponent(
        location.href
      )}`;
    } else {
      document.documentElement.scrollTop = 0;
      next();
    }
  }
});
//跳页 回到顶部
router.afterEach((to, from) => {
  let bodySrcollTop = document.body.scrollTop;
  if (bodySrcollTop !== 0) {
    document.body.scrollTop = 0;
    return;
  }
  let docSrcollTop = document.documentElement.scrollTop;
  if (docSrcollTop !== 0) {
    document.documentElement.scrollTop = 0;
  }

  if (store.state.interaction.completeList.length == 0) {
    // 获取我完成的任务
    store.dispatch("interaction/onGetCompleteTaskList");
  }
});
export default router;
